import MartyLoginAnimation from 'components/about/animations/MartyLoginAnimation';
import styles from './EmailVerification.module.css';

const EmailVerification = () => {
  return (
    <div className={styles.Container}>
      <div className={styles.Animation}>
        <MartyLoginAnimation />
      </div>
      <img alt="Rive" src="https://cdn.rive.app/icons/rive_logo_white.svg" />
      <h3>Thank you, your email address has been verified.</h3>
      <p>
        Head over to the{' '}
        <a className={styles.Link} href="/">
          home page
        </a>
        .
      </p>
    </div>
  );
};

export default EmailVerification;
